import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  TextField,
  Paper,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Tabs,
  Tab,
  Grid,
  Switch,
  Autocomplete,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NGROK } from "../../../APIs";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";
import { myLocalStorage } from "../../../components/StorageHelper";
import { awsIcons } from "./AWSIcons";
import useUserStore from "../../../services/userStore";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import { SiKubernetes } from "react-icons/si";
import { Shield as ShieldIcon } from "@mui/icons-material";
import K8Roles from "../Azure/Components/K8Roles";
import AWSGenericRoles from "./components/AWSGenericRoles";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useCloudSyncWatcher from "../../../services/useCloudSyncWatcher";
import useNotificationStore from "../../../services/notificationStore";
import { parseAwsPolicyDocument } from "./utils/parseAwsPolicyDocument";
import CloudFilters from "../../../components/v2components/CloudFilters";
import CloudRoleSelectorBar from "../CloudRoleSelectorBar";
import "../../../components/v2components/Cloud/CloudStatus.css";
import EmptyStateCard from "../../../components/v2components/EmptyStateCard";
import { Cloud } from "lucide-react";

const Wrapper = styled.div`
  max-height: 500px;
`;
const useStyles = makeStyles({
  root: {
    maxHeight: "500px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "10px",
    },
  },
});

const useStylesScroll = makeStyles({
  root: {
    maxHeight: 750,
    border: "1px solid",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888",
      borderRadius: "10px",
    },
  },
  row: {
    "& > td": {
      padding: "30px",
    },
  },
});

const AwsRoles = () => {
  const classes = useStyles();
  const classes1 = useStylesScroll();
  const [tabValue, setTabValue] = useState("Roles");
  const [roleFilter, setRoleFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [modalPermission, setModalPermission] = useState(null);
  const [filter, setFilter] = useState("all");
  const [selectedDetailsTab, setSelectedDetailsTab] = useState(0);
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRolesDetails, setShowRolesDetails] = useState(false);
  const [isPermissionLoading, setIsPermissionLoading] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [filteredPermission, setFilteredPermission] = useState([]);
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [filteredusers, setFilteredUsers] = useState([]);
  const [filteredgroups, setFilteredGroups] = useState([]);
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncError, setSyncError] = useState(null);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { awsConfig } = useNotificationStore.getState();
  const [awsAccountId, setAWSAccountId] = useState("");
  const [accounts, setAccounts] = useState([]);
  const selectedAwsAccount = myLocalStorage.getItem("selectedAwsAccount");

  const userData = useUserStore((state) => state.user);
  const handleDetailsTabChange = (event, newValue) => {
    setSelectedDetailsTab(newValue);
  };

  const handlePermissionSearch = (event) => {
    const search = event.target.value;
    const filteredPermission = consolidatedPermissions.filter(
      (permission) =>
        permission?.PolicyName &&
        permission?.PolicyName.toLowerCase().includes(search.toLowerCase()),
    );
    setFilteredPermission(filteredPermission);
  };

  const handleRoleSearchChange = (event) => {
    setSearch(event.target.value);
    setShowRolesDetails(false);
    setIsPermissionLoading(false);
  };

  const handleRoleClick = (role) => {
    setSelectedRole(role);
    setShowRolesDetails(false);
    setIsPermissionLoading(false);
  };

  const getTheSpecificPolicyDocument = async (policyArn) => {
    const data = `policyArn=${encodeURIComponent(policyArn)}`;

    try {
      const response = await axios.get(
        `${NGROK}/api/aws/getSpecificIAMPolicydetails?tenantName=${latestTenant}&policyarn=${encodeURIComponent(policyArn)}&accountId=${selectedAwsAccount}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      return response.data;
    } catch (error) {
      return null;
    }
  };
  const handlePermissionClick = (permission) => {
    setSelectedPermission(permission.policyARN);
    const policyArn = permission.policyARN;

    const groupsWithPolicy = users
      .flatMap((user) => user.groups || [])
      .filter((group) =>
        group.groupPolicies?.some((policy) => policy.policyARN === policyArn),
      );
    const usersWithPolicy = users.filter((user) => {
      const hasPolicyInGroups = user.groups?.some((group) =>
        group.groupPolicies?.some((policy) => policy.policyARN === policyArn),
      );
      const hasPolicyInUserPolicies = user.userPolicies?.some(
        (policy) => policy.policyARN === policyArn,
      );
      return hasPolicyInGroups || hasPolicyInUserPolicies;
    });

    setFilteredUsers(usersWithPolicy);
    setFilteredGroups(groupsWithPolicy);
  };

  const handlePolicyInfoOpen = async (permission) => {
    setIsPermissionLoading(true);
    const permissionDoc = await getTheSpecificPolicyDocument(
      permission.policyARN,
    );

    if (permissionDoc) {
      permissionDoc.policyDocument = parseAwsPolicyDocument(permissionDoc.policyDocument);
      console.log(permissionDoc);
      setModalPermission(permissionDoc);
      setShowRolesDetails(true);
    } else {
      setShowRolesDetails(false);
    }
    setIsPermissionLoading(false);
  };

  const handlePolicyInfoClose = () => {
    setModalPermission(null);
  };

  const handleFilterChange = (event, newFilter) => {
    const filteredRoles = filterRoles(roles, newFilter);
    setFilter(newFilter);
    setSelectedRole(filteredRoles.length > 0 ? filteredRoles[0] : null);
    setShowRolesDetails(false);
    setIsPermissionLoading(false);
    setSelectedPermission(null);
  };
  const handleAccountChange = (value) => {
    if (!value) {
      setLoading(false);
      setAWSAccountId("");
      setUsers([]);
      setGroups([]);
      setRoles([]);
      setSelectedRole(null);
      myLocalStorage.setItem("selectedAwsAccount", "");
      return;
    }
    setLoading(true);
    myLocalStorage.setItem("selectedAwsAccount", value);
    setAWSAccountId(value);
  };

  const ondemandButton = async () => {
    if (!awsAccountId) return;

    try {
      await triggerCloudSync(
        "aws",
        "/api/aws/ondemand",
        latestTenant,
        () => fetchData(),
      );
    } catch (error) {
      setAlertSeverity("error");
      setSyncError(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchAllAccounts();
  }, [latestTenant]);

  useCloudSyncWatcher("aws", latestTenant, () => fetchData());

  const getAllUsers = async () => {
    const response = await axios.get(
      `${NGROK}/api/aws/getIamusers?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`,
    );

    if (response.status === 200) return response.data;
    else return [];
  };

  const getAllRoles = async () => {
    const response = await axios.get(
      `${NGROK}/api/aws/getIamroles?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`,
    );
    if (response.status === 200) return response.data;
    else return [];
  };

  const fetchData = async (initialLoad = false) => {
    const selectedAwsAccount = myLocalStorage.getItem("selectedAwsAccount");
    if (!selectedAwsAccount) {
      setLoading(false);
      return;
    }
    try {
      const [users, roles] = await Promise.all([getAllUsers(), getAllRoles()]);
      setUsers(users);
      setRoles(roles);
      setLoading(false);
      if (initialLoad) {
        const filteredRoles = filterRoles(roles, filter);
        setSelectedRole(filteredRoles.length > 0 ? filteredRoles[0] : null);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setLoading(false);
    }
  };

  const fetchAllAccounts = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/aws/getAllAccounts?tenantName=${latestTenant}`,
      );

      if (response?.data) {
        const accounts = response.data.map((account) => ({
          label: account.accountName,
          value: account.accountId,
        }));

        setAccounts(accounts);

        if (accounts.length === 0) {
          setAWSAccountId("");
          setUsers([]);
          setGroups([]);
          setRoles([]);
          setSelectedRole(null);
          setLoading(false);
          myLocalStorage.setItem("selectedAwsAccount", "");
          return;
        }

        const storedAccountId = myLocalStorage.getItem("selectedAwsAccount");
        const accountExists = accounts.find(
          (account) => account.value === storedAccountId,
        );

        if (storedAccountId && accountExists) {
          setAWSAccountId(storedAccountId);
        } else {
          const defaultAccountId = accounts[0]?.value || "";
          setAWSAccountId(defaultAccountId);
          myLocalStorage.setItem("selectedAwsAccount", defaultAccountId);
        }
      }
    } catch (error) {
      console.error("Error fetching AWS accounts", error);
    }
  };

  useEffect(() => {
    fetchData(true);
  }, [selectedAwsAccount]);

  useEffect(() => {
    fetchAllAccounts();
  }, [latestTenant]);

  useCloudSyncWatcher("aws", latestTenant, () => fetchData());

  const filterRoles = (roles, filter) => {
    if (!roles) return [];

    return roles.filter((role) => {
      const { roleName } = role;

      if (roleName?.startsWith("Whiteswan")) return false;

      if (filter === "default") {
        return roleName?.startsWith("AWSServiceRoleFor");
      } else if (filter === "custom") {
        return !roleName?.startsWith("AWSServiceRoleFor");
      }

      return true;
    });
  };

  const filteredRoles = filterRoles(
    roles?.filter(
      (role) =>
        role?.roleName &&
        role?.roleName.toLowerCase().includes(search.toLowerCase()),
    ),
    filter,
  );

  const consolidatedPermissions = selectedRole
    ? [...selectedRole.rolePolicies]
    : [];

  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    setSelectedTenantName(value);
    if (tenant !== undefined) myLocalStorage.setItem("latestTenant", tenant);
  };

  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);

  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);

  const updatePermissionARN = async (arn) => {
    const updatedPermissions = filteredPermission.map((permission) => {
      if (permission.policyARN === arn) {
        return {
          ...permission,
          isManagedAttachedPolicies: !permission.isManagedAttachedPolicies,
        };
      }
      return permission;
    });

    try {
      const response = await axios.put(
        `${NGROK}/api/aws/publishPolicies?tenantName=${latestTenant}&policyARN=${arn}`,
      );
      fetchData();
    } catch (err) {
      console.err(err);
    }
    setFilteredPermission(updatedPermissions);
  };

  useEffect(() => {
    if (selectedRole) {
      setFilteredPermission(consolidatedPermissions);
    }
  }, [selectedRole]);

  return (
    <>
      {syncError && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setSyncError(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSyncError(null)}
            severity={alertSeverity}
            sx={{ width: "100%" }}
          >
            {syncError}
          </Alert>
        </Snackbar>
      )}
      <div className="h-full flex flex-col bg-background">
        <div className="flex flex-1 min-h-0 flex-col overflow-hidden p-6">
          <CloudFilters
            cloudProvider="aws"
            onTenantChange={handleTenantChange}
            onCloudAccountChange={handleAccountChange}
            isAdmin={true}
            onSync={ondemandButton}
            syncDisabled={!awsAccountId || syncStatus["aws"]}
            syncLoading={Boolean(awsAccountId) && syncStatus["aws"]}
          />

          {!awsAccountId ? (
            <EmptyStateCard
              icon={Cloud}
              title="No AWS account configured"
              description="Configure an AWS account for this tenant to view AWS roles."
            />
          ) : (
            <>
              <CloudRoleSelectorBar
                roleFilter={roleFilter}
                onRoleFilterChange={setRoleFilter}
                activeTab={tabValue}
                onTabChange={setTabValue}
                cloudProvider="aws"
              />

              {tabValue === "Roles" && (
                <AWSGenericRoles
                  latestTenant={latestTenant}
                  selectedAwsAccount={awsAccountId}
                  roleFilter={roleFilter}
                />
              )}
              {tabValue === "K8" && (
                <K8Roles
                  electedAwsAccount={selectedAwsAccount}
                  selectedTenantName={selectedTenantName}
                  allapi={`/api/aws/k8-clusters?tenantName=${selectedTenantName}`}
                  rolesApi="/api/k8-resources/v1/roles/byClusterId"
                  rolespoliciesApi="/api/k8-resources/v1/rolePolicies/byRoleUid"
                  cloud="AWS"
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AwsRoles;
